<script>
import Hero from '@/components/Hero.vue'
import Portfolio from '@/components/Portfolio.vue'

export default {
  functional: true,
  name: '',
  render(createElement) {
    const hero = createElement(Hero)
    const portfolio = createElement(Portfolio)

    return [hero,portfolio]
  }
}
</script>